var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "线索导入",
        width: "970px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "exportClue overflowOuto" }, [
        _c(
          "div",
          { staticClass: "filterHeader" },
          [
            _c(
              "el-row",
              [
                _c("span", { staticClass: "formLabel m-r-10" }, [
                  _vm._v("任务名称"),
                ]),
                _c("appTemplate", {
                  ref: "optionRef",
                  staticStyle: { width: "200px", "margin-right": "10px" },
                  attrs: {
                    multiple: true,
                    size: "small",
                    config: {
                      api: _vm.getTaskIdPage,
                      nameKey: "taskName",
                      label: "taskName",
                      value: "id",
                    },
                    placeholder: "请输入任务名称",
                  },
                  on: {
                    change: _vm.handleTasks,
                    focus: _vm.handleChangeTaskIdPage,
                  },
                  model: {
                    value: _vm.search.taskId,
                    callback: function ($$v) {
                      _vm.$set(_vm.search, "taskId", $$v)
                    },
                    expression: "search.taskId",
                  },
                }),
                _c("span", { staticClass: "formLabel m-r-10" }, [
                  _vm._v("分配日期"),
                ]),
                _c("el-date-picker", {
                  staticClass: "m-r-10 input-with-time",
                  staticStyle: { width: "292px" },
                  attrs: {
                    size: "small",
                    type: "daterange",
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "unlink-panels": true,
                    "picker-options": _vm.pickerOptions,
                  },
                  on: { change: _vm.handleClickSearch, focus: _vm.focus },
                  model: {
                    value: _vm.search.time,
                    callback: function ($$v) {
                      _vm.$set(_vm.search, "time", $$v)
                    },
                    expression: "search.time",
                  },
                }),
                _c("span", { staticClass: "formLabel m-r-10" }, [
                  _vm._v("订单状态"),
                ]),
                _c(
                  "el-select",
                  {
                    staticClass: "w_f_120",
                    attrs: {
                      size: "small",
                      placeholder: "请选择",
                      clearable: "",
                    },
                    on: { clear: _vm.searchFn, change: _vm.searchFn },
                    model: {
                      value: _vm.search.orderStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "orderStatus", $$v)
                      },
                      expression: "search.orderStatus",
                    },
                  },
                  _vm._l(_vm.orderStatusList, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "m-t-10" },
              [
                _c("span", { staticClass: "formLabel m-r-10" }, [
                  _vm._v("标签"),
                ]),
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      filterable: "",
                      clearable: "",
                      remote: "",
                      "reserve-keyword": "",
                      "remote-method": _vm.getTagList,
                    },
                    on: { change: _vm.searchFn },
                    model: {
                      value: _vm.search.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "tags", $$v)
                      },
                      expression: "search.tags",
                    },
                  },
                  _vm._l(_vm.TagOptions, function (item, index) {
                    return _c("el-option", {
                      key: `${item.wechatTagId}${index}`,
                      attrs: { value: item.id, label: item.tagName },
                    })
                  }),
                  1
                ),
                _c("span", { staticClass: "formLabel m-r-10 m-l-10" }, [
                  _vm._v("商品类型"),
                ]),
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", clearable: "" },
                    on: { clear: _vm.searchFn, change: _vm.searchFn },
                    model: {
                      value: _vm.search.productCategory,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "productCategory", $$v)
                      },
                      expression: "search.productCategory",
                    },
                  },
                  _vm._l(_vm.GOODS_TYPE, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { value: item.value, label: item.label },
                    })
                  }),
                  1
                ),
                _c("span", { staticClass: "formLabel m-r-10 m-l-10" }, [
                  _vm._v("商品名称"),
                ]),
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      filterable: "",
                      clearable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "请输入商品名称",
                      "remote-method": _vm.remoteMethodGoods,
                      loading: _vm.goodsLoading,
                    },
                    on: { change: _vm.searchFn, clear: _vm.searchFn },
                    model: {
                      value: _vm.search.goodsId,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "goodsId", $$v)
                      },
                      expression: "search.goodsId",
                    },
                  },
                  _vm._l(_vm.goodsList, function (item) {
                    return _c("el-option", {
                      key: item.goodsId,
                      attrs: { label: item.goodsName, value: item.goodsId },
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "m-l-10",
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.searchFn },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "m-l-10",
                    attrs: { size: "small" },
                    on: { click: _vm.clearFn },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "exportClueContent myTable",
          },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                attrs: {
                  height: "502",
                  "header-cell-style": { background: "#F3F3F3" },
                  data: _vm.list,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "phone", label: "学员电话" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("watchPhoneNumber", {
                            attrs: {
                              "default-value": row.phone,
                              params: row,
                              "user-id": row.userId,
                              "get-api": _vm.operationLogsWrite,
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "wechatNickName", label: "微信昵称" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "followUserName", label: "跟进人" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("div", { staticClass: "tipsError" }, [
                  _c("span", { staticClass: "tips c_red" }, [
                    _vm._v(_vm._s(_vm.errTips)),
                  ]),
                ]),
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                    "pager-count": 5,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }